// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_school,
  add_school,
  update_school,
  delete_school,
  get_school_list,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";
const initialState = {
  schools: [],
  schoollist: [],
  schoolfilterlist: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name:"",
    email:"",
    short_form:"",
    address:"",
    school_code:"",
    website:"",
    title:"",
    mobile_no:"",
    slogan:"",
    description:""
  },
};
// Async Thunks for API Calls
export const fetchschoolList = createAsyncThunk(
  "school/fetchschoolList",
  async ({school_id,department_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_school_list(school_id,department_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchfilterschoolList = createAsyncThunk(
  "school/fetchfilterschoolList",
  async ({school_id,department_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_school_list(school_id,department_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Async Thunks for API Calls
export const fetchschool = createAsyncThunk(
  "school/fetchschool",
  async ({ page, page_size,school_id,department_id,token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_school(page, page_size,school_id,department_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createschool = createAsyncThunk(
  "school/createschool",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_school(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateschool = createAsyncThunk(
  "school/updateschool",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_school(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteschool = createAsyncThunk(
  "school/deleteschool",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_school({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const schoolSlice = createSlice({
  name: "schools",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(reduxState, action) {
      reduxState.formData = { ...action.payload };
    },
    resetFormData(state) {
      state.formData = {
        name:"",
        email:"",
        short_form:"",
        address:"",
        school_code:"",
        website:"",
        title:"",
        mobile_no:"",
        slogan:"",
        description:""
      };
    },
    setschool(state, action) {
      state.schools = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // User list
      .addCase(fetchschoolList.fulfilled, (state, action) => {
        state.schoollist = action.payload.data;
      })
      .addCase(fetchschoolList.rejected, (state, action) => {
        state.schoollist = [];

      })
      .addCase(fetchfilterschoolList.fulfilled, (state, action) => {
        state.schoolfilterlist = action.payload.data;
      })
      .addCase(fetchfilterschoolList.rejected, (state, action) => {
        state.schoolfilterlist = [];

      })
      // Fetch Classes
      .addCase(fetchschool.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchschool.fulfilled, (state, action) => {
        state.loading = false;
        state.schools = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchschool.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createschool.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createschool.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createschool.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action;
        console.log(action)
        toast.info(action?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateschool.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateschool.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateschool.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deleteschool.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteschool.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteschool.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");

        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setschool,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize,
  setSchoolId,
} = schoolSlice.actions;
export default schoolSlice.reducer;
